import { AdmCreateRequestDto } from "@/dto/AdmDto";
import { useState } from "react";
import { createAdminBySuper } from "@/apis/admin";
import { useNavigate } from "react-router-dom";
import { useModal } from "mui-modal-provider";
import { Alert, Confirm } from "@/organism";
import { ErrorDto } from "@/dto/ErrorDto";

export default function useCreate() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { showModal } = useModal();

  /**
   * 관리자 생성
   */
  const handleAdmCreate = async (adm: AdmCreateRequestDto) => {
    const modal = showModal(Confirm, {
      title: "관리자 생성",
      content: "관리자를 생성하시겠습니까?",
      onOk: async () => {
        modal.destroy();
        try {
          setIsLoading(true);
          const response = await createAdminBySuper(adm);
          if (response) {
            navigate("/admins");
          }
        } catch (error) {
          const e = error as ErrorDto;
          showModal(Alert, {
            title: "관리자 생성 실패",
            content: e.error || "관리자 생성에 실패했습니다.",
            onClose: () => {
              modal.destroy();
            },
          });
          console.error(e);
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  return {
    isLoading,
    handleAdmCreate,
  };
}
